import ImmutableModel from '../immutable.model';

/**
 * A service category retrieved from the backend.
 */
class ServiceCategory extends ImmutableModel {

  /**
   * @param {Number} id
   * @param {String} name
   * @param {Number} order_number
   */
  constructor(
    id,
    name,
    order_number
  ) {
    super();

    this.id = id;
    this.name = name;
    this.order_number = order_number
  }

  copy() {
    return new ServiceCategory(this.id, this.name, this.order_number);
  }
}

export default ServiceCategory;



// WEBPACK FOOTER //
// ./src/app/common/models/servicecategory.model.js